/**
 * Side cart (assets/emk-cart.css): the discount code field opens/closes on its title (Figma 282:805 "+" / "−").
 * Only adds a class; the apply/clear logic stays in custom.js. The state survives the theme's cart re-render
 * (re-applied on theme:loading:end), stored in sessionStorage.
 */
(function () {
  var KEY = "emk_cart_discount_open";

  function stored() {
    try { return sessionStorage.getItem(KEY) === "1"; } catch (e) { return false; }
  }

  function store(open) {
    try { sessionStorage.setItem(KEY, open ? "1" : "0"); } catch (e) {}
  }

  function apply() {
    document.querySelectorAll("#mini-cart [data-cart-discount]").forEach(function (form) {
      var error = form.querySelector("[data-cart-discount-error]");
      var open = stored() || (error && !error.hidden);
      form.classList.toggle("is-open", !!open);
      var title = form.querySelector(".cart-discount-form__title");
      if (title) {
        title.setAttribute("role", "button");
        title.setAttribute("tabindex", "0");
        title.setAttribute("aria-expanded", open ? "true" : "false");
      }
    });
  }

  function toggle(title) {
    var form = title.closest("[data-cart-discount]");
    var open = !form.classList.contains("is-open");
    form.classList.toggle("is-open", open);
    title.setAttribute("aria-expanded", open ? "true" : "false");
    store(open);
    if (open) {
      var input = form.querySelector("[data-cart-discount-input]");
      if (input) input.focus();
    }
  }

  document.addEventListener("click", function (event) {
    var title = event.target.closest && event.target.closest("#mini-cart .cart-discount-form__title");
    if (title) toggle(title);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    var title = event.target.closest && event.target.closest("#mini-cart .cart-discount-form__title");
    if (!title) return;
    event.preventDefault();
    toggle(title);
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", apply);
  else apply();
  document.addEventListener("theme:loading:end", function () { setTimeout(apply, 0); });
})();

/**
 * Terms checkbox: keep the tick after the cart HTML is redrawn.
 * custom.js (WD Market) saves the tick in sessionStorage "emk_cart_terms" and restores it on DOMContentLoaded and
 * theme:loading:end — but Warehouse swaps in the new cart HTML after that event (quantity change, the fee/warranty
 * sync refresh right after a page load), so the fresh, unticked box won. Re-apply the saved state whenever the
 * cart markup changes. Setting .checked does not change the markup, so this cannot loop.
 */
(function () {
  var KEY = "emk_cart_terms";

  function applyTerms() {
    var saved = false;
    try { saved = sessionStorage.getItem(KEY) === "1"; } catch (e) { return; }
    document.querySelectorAll("[data-cart-terms] [data-cart-terms-input]").forEach(function (input) {
      if (input.checked !== saved) input.checked = saved;
      if (saved) {
        var error = input.closest("[data-cart-terms]").querySelector("[data-cart-terms-error]");
        if (error) error.hidden = true;
      }
    });
  }

  /**
   * "Add N more" strip under a line (Figma Side-Cart 282:657 / 282:1169).
   * custom.js renderAdPrompts (WD Market) decides when it shows and fills it with its own wording; here it is
   * re-worded to the Figma copy, keeping custom.js's [data-action="ad-add"] button so the add still works:
   *   "Pievieno vēl <1 preci> un ietaupi <€6,08>!"  [-15%]
   * When the AD_ target is already reached (custom.js leaves the slot empty): "Lieliski! Tu ietaupīji €6,08 🎉" [-15%].
   * Rules come from the AD_B<buy><PD|FP|FD><value>_<group> product tags in the cart-ad-data payload.
   */
  var AD_RE = /^AD_B(\d+)(PD|FP|FD)(\d+)_(.+)$/;

  function adPayload() {
    var node = document.querySelector("[data-cart-ad]");
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function euro(cents) {
    return "€" + (Math.max(0, cents) / 100).toFixed(2).replace(".", ",");
  }

  function savings(rule, price) {
    if (rule.kind === "PD") return Math.round((rule.buy * price * rule.value) / 100);
    if (rule.kind === "FP") return Math.round(rule.buy * (price - rule.value));
    if (rule.kind === "FD") return rule.buy * rule.value;
    return 0;
  }

  function pill(rule) {
    return rule.kind === "PD" ? '<span class="emk-ad__pill">-' + rule.value + "%</span>" : "";
  }

  function enhanceAdPrompts() {
    var payload = adPayload();
    if (!payload || !payload.lines) return;

    // AD_ groups in the cart: rule, total quantity, lines
    var groups = {};
    // Products a store discount already applies to (e.g. automatic "ILC 2+1" with its free line): no strip
    var discounted = {};
    payload.lines.forEach(function (line) {
      if (line.disc > 0 || !(line.price > 0)) discounted[line.product] = true;
    });
    payload.lines.forEach(function (line) {
      if (line.product && discounted[line.product]) return;
      if (!(line.price > 0)) return; // free lines (gifts, 100% off): no strip and not counted in the deal
      (line.tags || []).forEach(function (tag) {
        var m = String(tag).match(AD_RE);
        if (!m) return;
        var rule = { buy: +m[1], kind: m[2], value: +m[3], group: m[4] };
        if (!groups[rule.group]) groups[rule.group] = { rule: rule, qty: 0, lines: [] };
        groups[rule.group].qty += line.qty;
        groups[rule.group].lines.push(line);
      });
    });
    // Per line, like custom.js: the first rule (tag order) that still needs items; otherwise the biggest one reached
    payload.lines.forEach(function (line) {
      var pick = null;
      var reached = null;
      (line.tags || []).forEach(function (tag) {
        var m = String(tag).match(AD_RE);
        if (!m) return;
        var g = groups[m[4]];
        if (!g) return;
        if (g.qty < g.rule.buy) { if (!pick) pick = g; }
        else if (!reached || g.rule.buy > reached.rule.buy) reached = g;
      });
      line.emkAd = pick ? { group: pick, missing: pick.rule.buy - pick.qty } : reached ? { group: reached, missing: 0 } : null;
    });

    document.querySelectorAll("#mini-cart .cart-line-extras__ad").forEach(function (slot) {
      var lineNo = slot.getAttribute("data-ad-line");
      var line = payload.lines.filter(function (l) { return String(l.line) === String(lineNo); })[0];
      if (line && (!(line.price > 0) || (line.product && discounted[line.product]))) {
        if (slot.innerHTML) slot.innerHTML = "";
        if (!slot.hidden) slot.hidden = true;
        return;
      }
      if (!line || !line.emkAd) return;
      if (window.emkPackHints && window.emkPackHints[lineNo]) return; // the pack price saves more: that strip shows
      var rule = line.emkAd.group.rule;
      var missing = line.emkAd.missing;
      var save = euro(savings(rule, line.price));
      var html;
      if (missing > 0) {
        // Same button custom.js renders: its document click handler adds the missing quantity to this line
        html = '<span class="emk-ad__text">Pievieno vēl <button type="button" class="cart-line-extras__ad-add link" data-action="ad-add" data-line="' + line.line + '" data-add="' + missing + '">' + missing + (missing === 1 ? " preci" : " preces") + "</button> un ietaupi <strong>" + save + "</strong>!</span>" + pill(rule);
      } else {
        html = '<span class="emk-ad__text">Lieliski! Tu ietaupīji <strong>' + save + "</strong> &#127881;</span>" + pill(rule);
      }
      // custom.js may re-render the slot with its own wording on a cart refresh; this observer puts ours back
      if (slot.innerHTML !== html) slot.innerHTML = html;
      if (slot.hidden) slot.hidden = false;
    });
  }

  function watch() {
    // Whole body: Warehouse can replace the header section that holds the cart, which would detach a narrower root
    var root = document.body;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      // setTimeout, not requestAnimationFrame: rAF does not run while the tab is not being painted
      setTimeout(function () { queued = false; applyTerms(); enhanceAdPrompts(); }, 0);
    }).observe(root, { childList: true, subtree: true });
    applyTerms();
    enhanceAdPrompts();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watch);
  else watch();
})();

/**
 * Mouse wheel inside the side cart (QA: Firefox desktop, the product list did not scroll).
 * Scroll the cart (.mini-cart__inner: products + recap, QA item 5) directly from the wheel, wherever the cursor is in the panel (header,
 * delivery bar, products, footer). A wheel over the cart never scrolls the page behind.
 */
(function () {
  function canMove(el, dy) {
    if (!el || el.scrollHeight <= el.clientHeight + 1) return false;
    return dy > 0 ? el.scrollTop + el.clientHeight < el.scrollHeight - 1 : el.scrollTop > 0;
  }

  document.addEventListener("wheel", function (event) {
    if (event.ctrlKey || !event.deltaY || !event.target.closest) return;
    var cart = event.target.closest('#mini-cart[aria-hidden="false"]');
    if (!cart) return;
    var list = cart.querySelector(".mini-cart__inner") || cart.querySelector(".mini-cart__content"); // .mini-cart__inner scrolls (QA item 5)
    var dy = event.deltaY;
    if (event.deltaMode === 1) dy *= 40; // Firefox often reports lines
    else if (event.deltaMode === 2) dy *= (list ? list.clientHeight : 400);

    event.preventDefault();
    if (canMove(list, dy)) list.scrollTop += dy;
  }, { passive: false });
})();

/**
 * "Pievieno vēl N preces un ietaupi €…" for products sold in packs (QA item 6). The cart never swaps the product:
 * 3 × 1 kg stays one 1 kg line, and its 3 kg price comes from a Shopify automatic discount on that line (minimum
 * quantity 3 / 6, set up in admin to match the pack price). This strip only tells how many more single packs reach
 * the next pack size and what that saves — the button adds them to the same line (custom.js data-action="ad-add").
 * Pack sizes come from the SKU like everywhere in the theme: the first variant = 1 pack, "<n>x<first variant SKU>" =
 * n packs (e.g. CF010103 / 3xCF010103 / 6xCF010103, see emk-unit-tiers.liquid). When the product also has an AD_ deal
 * (2+1 …), the strip with the bigger saving shows.
 */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var products = {};
  var hints = {};
  var busy = false;

  function json(url) {
    return fetch(root + url, { headers: { Accept: "application/json" } }).then(function (r) {
      if (!r.ok) throw new Error(url);
      return r.json();
    });
  }

  function product(handle) {
    if (!products[handle]) products[handle] = json("products/" + handle + ".js").catch(function () { return null; });
    return products[handle];
  }

  // Bigger packs of the product, smallest first: [{ n, price, compare }] (the 1-pack variant is p.variants[0])
  function packsOf(p) {
    if (!p || !p.variants || !p.variants.length || !p.variants[0].sku) return [];
    var base = p.variants[0];
    var list = [];
    p.variants.forEach(function (v) {
      var m = String(v.sku || "").match(/^(\d+)x(.+)$/);
      if (m && m[2] === base.sku && +m[1] > 1) list.push({ n: +m[1], price: v.price, compare: v.compare_at_price || 0 });
    });
    return list.sort(function (a, b) { return a.n - b.n; });
  }

  var AD_RE = /^AD_B(\d+)(PD|FP|FD)(\d+)_(.+)$/;

  function adSave(rule, unit) {
    if (rule.kind === "PD") return Math.round((rule.buy * unit * rule.value) / 100);
    if (rule.kind === "FP") return Math.round(rule.buy * (unit - rule.value));
    if (rule.kind === "FD") return rule.buy * rule.value;
    return 0;
  }

  // The product's AD_ deal (2+1 …): { buy, save } — save = what one full set (buy pieces) saves.
  function adOffer(p, unit) {
    var payload = null;
    try { payload = JSON.parse(document.querySelector("[data-cart-ad]").textContent); } catch (e) {}
    var best = null;
    (p.tags || []).forEach(function (tag) {
      var m = String(tag).match(AD_RE);
      if (!m) return;
      var rule = { buy: +m[1], kind: m[2], value: +m[3], group: m[4] };
      var qty = 0;
      ((payload && payload.lines) || []).forEach(function (l) {
        if (l.price > 0 && (l.tags || []).indexOf(tag) !== -1) qty += l.qty;
      });
      var offer = { buy: rule.buy, save: adSave(rule, unit), other: Math.max(0, qty) };
      if (offer.save > 0 && (!best || offer.save / offer.buy > best.save / best.buy)) best = offer;
    });
    return best;
  }

  function hasProps(item) {
    return item.properties && Object.keys(item.properties).some(function (k) { return item.properties[k] !== "" && item.properties[k] != null; });
  }

  function euro(cents) {
    return "€" + (cents / 100).toFixed(2).replace(".", ",");
  }

  function apply() {
    // Side cart only (#mini-cart); the /cart page gets no pack strip
    document.querySelectorAll("#mini-cart .cart-line-extras__ad").forEach(function (slot) {
      var hint = hints[slot.getAttribute("data-ad-line")];
      if (!hint) return;
      var html = '<span class="emk-ad__text">Pievieno vēl <button type="button" class="cart-line-extras__ad-add link" data-action="ad-add" data-line="' + hint.line + '" data-add="' + hint.missing + '">' + hint.missing + (hint.missing === 1 ? " preci" : " preces") + "</button> un ietaupi <strong>" + euro(hint.save) + "</strong>!</span>" + (hint.pct > 0 ? '<span class="emk-ad__pill">-' + hint.pct + "%</span>" : "");
      if (slot.innerHTML !== html) slot.innerHTML = html;
      if (slot.hidden) slot.hidden = false;
    });
  }

  function update() {
    if (busy) return;
    busy = true;
    json("cart.js").then(function (cart) {
      var lines = cart.items.map(function (item, i) { return { item: item, line: i + 1 }; }).filter(function (l) {
        return !hasProps(l.item) && !l.item.selling_plan_allocation;
      });
      var handles = [];
      lines.forEach(function (l) { if (handles.indexOf(l.item.handle) === -1) handles.push(l.item.handle); });
      // Products that already have a Shopify discount on any of their lines (e.g. automatic "ILC 2+1", which adds the
      // free piece as its own line): no pack notice — the store's own deal is what applies to them
      var discounted = {};
      cart.items.forEach(function (i) {
        if ((i.line_level_discount_allocations || []).length || (i.discounts || []).length) discounted[i.product_id] = true;
      });
      return Promise.all(handles.map(product)).then(function (list) {
        var next = {};
        lines.forEach(function (l) {
          var p = list[handles.indexOf(l.item.handle)];
          if (!p || l.item.variant_id !== p.variants[0].id) return; // only the 1-pack line
          if (discounted[l.item.product_id]) return; // a store deal (2+1 …) already applies to this product
          if (!(l.item.final_price > 0)) return; // free product (gift, 100% off): no notice
          var base = p.variants[0].price;
          // 2+1 products (tag "icon_2+1", automatic "ILC 2+1" in admin): the third piece is free, so the strip offers
          // that instead of the 3 kg pack — 1 in the cart: "Pievieno vēl 2 preces", 2: "Pievieno vēl 1 preci", saving = one
          // piece's price. From 3 on (or once Shopify has added the free line, see `discounted` above): nothing.
          if ((p.tags || []).indexOf("icon_2+1") !== -1) {
            if (l.item.quantity < 3) next[l.line] = { line: l.line, missing: 3 - l.item.quantity, save: base, pct: 33 };
            return;
          }
          return; // only 2+1 products get the strip; pack-only products (e.g. FORTE 1/3/6 kg) show nothing
          var target = packsOf(p).filter(function (pk) { return pk.n > l.item.quantity; })[0];
          if (!target) return; // already at the biggest pack size
          // Same crossed-out price as the product page tiers (emk-unit-tiers.liquid): n × 1-pack price, or the pack's
          // compare-at price when that is higher — so the cart and the product page show the same saving
          var full = Math.max(target.n * base, target.compare);
          var save = full - target.price;
          if (save <= 0) return;
          // Product with an AD_ deal too (2+1 …): show whichever saves more. The cart itself gets the bigger one from
          // Shopify (automatic discounts that do not combine: Shopify applies the one with the greatest saving).
          // Both compared at the same quantity (the next pack size): the deal saves once per full set
          var deal = adOffer(p, base);
          if (deal && Math.floor(target.n / deal.buy) * deal.save >= save) return; // deal better: its own strip stays
          if (target.n !== packsOf(p)[0].n) return; // only up to the first pack size (1 or 2 × 1 kg → 3 kg); from 3 on: nothing
          next[l.line] = { line: l.line, missing: target.n - l.item.quantity, save: save, pct: Math.round((save / full) * 100) };
        });
        hints = next;
        window.emkPackHints = next; // enhanceAdPrompts leaves these lines to us
        apply();
      });
    }).then(function () { busy = false; }, function () { busy = false; });
  }

  // custom.js renderAdPrompts empties strips it did not make on every cart redraw: put ours back
  function watch() {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; apply(); }, 0);
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Pack strip on, but only towards the first pack size: 1 × 1 kg → "Pievieno vēl 2 preces", 2 × 1 kg → "Pievieno vēl 1 preci"
  // (3 kg price). From 3 × 1 kg on (the next step would be 6 kg) nothing shows.
  var PACK_HINTS = true;

  function start() {
    window.emkPackHints = {};
    if (!PACK_HINTS) return;
    watch();
    update();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
  document.addEventListener("theme:loading:end", function () { if (PACK_HINTS) setTimeout(update, 0); });
})();

/**
 * Cart scroll (QA item 5): the whole cart scrolls as one list, checkout button at the end (emk-cart.css).
 * The theme redraws the cart from the server after every +/− (theme.js _rerender), which would put the scroll back
 *   to the top; keep the shopper's place. Back to the top when the cart is closed.
 */
(function () {
  var lastTop = 0;

  function scroller() {
    return document.querySelector("#mini-cart .mini-cart__inner");
  }

  document.addEventListener("scroll", function (event) {
    var t = event.target;
    if (t && t.classList && t.classList.contains("mini-cart__inner") && t.closest("#mini-cart")) lastTop = t.scrollTop;
  }, true);

  function watch() {
    var cart = document.getElementById("mini-cart");
    if (!cart || !window.MutationObserver) return;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === "attributes") {
          if (cart.getAttribute("aria-hidden") === "true") lastTop = 0;
          return;
        }
        var el = scroller();
        if (el && lastTop && el.scrollTop !== lastTop) el.scrollTop = lastTop; // before paint: no jump
      });
    }).observe(cart, { childList: true, attributes: true, attributeFilter: ["aria-hidden"] });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watch);
  else watch();
})();

/**
 * Unlock offer set (snippets/mini-cart-offer-set.liquid):
 * - "Noņemt komplektu" removes every line of the set in one /cart/update.js call;
 * - "+" in the pick list adds one of that item to the set (same _offer_group, so it joins the set's line);
 * - the pick list's open/closed state survives the cart redraw (sessionStorage per set).
 * After a change the theme redraws the cart (cart:refresh, header listens on <html>).
 */
(function () {
  var PICK_KEY = "emk_uo_pick_";

  function refresh() {
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { scrollToTop: false } }));
  }

  function restorePicks() {
    document.querySelectorAll("#mini-cart [data-uo-pick]").forEach(function (d) {
      var saved = null;
      try { saved = sessionStorage.getItem(PICK_KEY + d.getAttribute("data-uo-pick")); } catch (e) {}
      if (saved === "1") d.open = true;
      else if (saved === "0" && !d.open) d.open = false;
    });
  }

  document.addEventListener("toggle", function (event) {
    var d = event.target;
    if (!d || !d.matches || !d.matches("#mini-cart [data-uo-pick]")) return;
    try { sessionStorage.setItem(PICK_KEY + d.getAttribute("data-uo-pick"), d.open ? "1" : "0"); } catch (e) {}
  }, true);
  document.addEventListener("theme:loading:end", function () { setTimeout(restorePicks, 0); });

  document.addEventListener("click", function (event) {
    var add = event.target.closest && event.target.closest("#mini-cart [data-uo-add-pool]");
    if (!add || add.disabled) return;
    event.preventDefault();
    add.disabled = true;
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
    fetch(root + "cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ items: [{
        id: parseInt(add.getAttribute("data-uo-add-pool"), 10),
        quantity: 1,
        properties: { _offer: add.getAttribute("data-uo-offer"), _offer_role: "pool", _offer_group: add.getAttribute("data-uo-group") }
      }] })
    }).finally(refresh);
  });
})();

(function () {
  document.addEventListener("click", function (event) {
    var button = event.target.closest && event.target.closest("#mini-cart [data-uo-remove]");
    if (!button || button.disabled) return;
    event.preventDefault();
    var updates = {};
    button.getAttribute("data-uo-remove").split(",").forEach(function (key) { if (key) updates[key] = 0; });
    button.disabled = true;
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
    fetch(root + "cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ updates: updates })
    }).finally(function () {
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { scrollToTop: false } }));
    });
  });
})();
